/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
import GetNavigationConfigByOrderState from '../../configs/routes.config';
import GetNavigationViewConfigByOrderState from '../../configs/navigation-view.config';

export const getVehicleImageUrl = stockNumber =>
  `${process.env.VEHICLE_IMAGE_CDN_URL}/${stockNumber}/post-large/${stockNumber}-edc-02-search.jpg`;

export const getCloseUpVehicleImageUrl = stockNumber =>
  `${process.env.VEHICLE_IMAGE_CDN_URL}/${stockNumber}/post-large/normalized/zoomcrop/${stockNumber}-edc-02.jpg`;

export const setDashboardModuleStatus = (newStatus = {}) => {
  const statusCssClass = newStatus?.actionIsRequired
    ? 'actionRequired'
    : newStatus?.isComplete
    ? 'complete'
    : newStatus?.isDisabled
    ? 'disabled'
    : 'pending';

  return {
    actionRequiredName: null,
    actionIsRequired: false,
    isComplete: false,
    isDisabled: false,
    statusCssClass,
    ...newStatus
  };
};

const getStepByStepName = (stepName, steps) => {
  return steps[stepName] || {};
};

const getOrderState = (orderStatus, steps, needsToScheduleTimeSlot) => {
  if (!steps) return orderStatus;

  if (orderStatus === 'OrderPlaced') {
    if (needsToScheduleTimeSlot) return 'Underwriting';

    if (!needsToScheduleTimeSlot) {
      const insuranceOptions = getStepByStepName('insuranceOptions', steps);

      if (
        insuranceOptions?.isEnabled &&
        insuranceOptions?.status === 'Incomplete'
      ) {
        return 'Underwriting';
      }
    }
  }

  return orderStatus;
};

const getCurrentRoutes = (orderState, steps, experiments) => {
  const inProgressStep = { name: null, index: null };

  const setIsComplete = navItem => {
    if (!navItem.navigation) return navItem;
    navItem.isComplete = navItem?.status === 'Complete';

    return navItem;
  };

  const setInProgress = (navItem, index, items) => {
    if (!navItem.navigation) return navItem;

    const prevNavItem = index > 0 && items[index - 1];

    navItem.inProgress =
      !navItem.isComplete &&
      (!prevNavItem || prevNavItem.isComplete) &&
      !inProgressStep.name;

    if (navItem.inProgress) {
      inProgressStep.name = navItem.name;
      inProgressStep.index = index;
    }

    return navItem;
  };

  const setIsDisabled = (navItem, index) => {
    if (!navItem.navigation) return navItem;

    navItem.isDisabled =
      (index > 0 && !navItem.inProgress && index > inProgressStep.index) ||
      inProgressStep.index === null;

    return navItem;
  };

  const getGapExperimentNavOrder = () => {
    const currentRoutes = GetNavigationConfigByOrderState(orderState);
    if (currentRoutes.length > 0) {
      const gapIndex = currentRoutes.findIndex(x => x.id === 130);
      const toIndex = currentRoutes.findIndex(x => x.id === 150);
      const element = currentRoutes?.splice(gapIndex, 1)[0];
      currentRoutes?.splice(toIndex, 0, element);
    }
    return currentRoutes;
  };

  const getCurrentNavSteps = () => {
    const bucket = experiments['ptp-step-order-2022'];
    switch (bucket) {
      case 'treatment': {
        return getGapExperimentNavOrder();
      }
      default:
        return GetNavigationConfigByOrderState(orderState);
    }
  };

  const currentRoutes = getCurrentNavSteps()
    .filter(navConfigItem => {
      return (
        steps[navConfigItem.name]?.isEnabled ||
        !navConfigItem.navigation ||
        navConfigItem.name === 'verifications'
      );
    })
    .map(x => ({ ...x, ...(steps && steps[x.name]) }))
    .map(setIsComplete)
    .map(setInProgress)
    .map(setIsDisabled);

  return currentRoutes;
};

const showWidgetBar = (orderState, needsToScheduleTimeSlot) => {
  if (!orderState) return false;
  if (orderState === 'OrderPlaced') return false;
  if (orderState === 'Underwriting' && needsToScheduleTimeSlot) return true;
  if (orderState === 'Underwriting' && !needsToScheduleTimeSlot) return false;

  return orderState !== 'OrderPlaced';
};

const showCart = (orderState, isAvailable) => {
  if (!orderState) return false;
  if (orderState === 'OrderPlaced') return false;
  if (!isAvailable) return false;

  return orderState === 'InProgress';
};

const showLockTimer = (orderState, needsToScheduleTimeSlot) => {
  if (!orderState) return false;
  if (orderState === 'OrderPlaced') return false;
  if (orderState === 'Underwriting' && needsToScheduleTimeSlot) return true;
  if (orderState === 'Underwriting' && !needsToScheduleTimeSlot) return false;

  return orderState !== 'OrderPlaced';
};

export const GetNavigationConfiguration = (
  orderStatus,
  steps,
  needsToScheduleTimeSlot,
  experiments,
  isAvailable
) => {
  const orderState = getOrderState(orderStatus, steps, needsToScheduleTimeSlot);
  const navItems = getCurrentRoutes(orderState, steps, experiments);
  const navConfigs = GetNavigationViewConfigByOrderState(orderState);

  return {
    navItems,
    ...navConfigs,
    widgetBar: {
      showWidgetBar: showWidgetBar(orderState, needsToScheduleTimeSlot),
      showCart: showCart(orderState, isAvailable),
      showLockTimer: showLockTimer(orderState, needsToScheduleTimeSlot)
    }
  };
};
